'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const DiagramView = require('balus/ui/view/body/diagram/content/diagram');
const DetailView = require('balus/ui/view/body/diagram/content/detail');
const Template = require('balus/ui/template/body/diagram/content/index.hbs')

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        diagram: '#diagram',
        detail: '#detail'
    },
    templateContext: function() {
        return {
            isLocked: this.getOption('auth').isLocked()
        };
    },
    onRender: function() {
        this._auth = this.getOption('auth');

        this.showChildView('diagram', new DiagramView({
            model: this.model,
            group: this.getOption('group'),
            project: this.getOption('project'),
            user: this.getOption('user'),
            context: this.getOption('context'),
            oldContext: this.getOption('oldContext'),
            channel: this.getOption('channel'),
            auth: this.getOption('auth'),
        }));
        this.showChildView('detail', new DetailView({
            model: this.model,
            context: this.getOption('context'),
            oldContext: this.getOption('oldContext'),
            channel: this.getOption('channel'),
            auth: this.getOption('auth'),
            user: this.getOption('user'),
            group: this.getOption('group'),
            project: this.getOption('project'),
            appInfo: this.getOption('appInfo')
        }));
    },
    setLockState: function() {
        if (this._auth.isLocked()) {
            this.$('#diagram').addClass('is-locked');
        } else {
            this.$('#diagram').removeClass('is-locked');
        }
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram/content/index.js